import styled, { css } from 'styled-components';
import { hoverPopAnimation } from '../../commons';
import { animationShow } from '../../Products/utils/animations';
var animationShowStyles = css(["", ";"], animationShow);
var innerStyles = css(["display:flex;flex-direction:column;justify-content:space-between;border-radius:4px;font-size:16px;line-height:18px;text-align:left;&:hover{svg{", ";transform:scale(1.05);}}", ""], hoverPopAnimation, function (props) {
  return props.animationShow && animationShowStyles;
});
export var Inner = styled.div.withConfig({
  displayName: "Inner",
  componentId: "sc-h9rhyh-0"
})(["", ""], innerStyles);
export var InnerLink = styled.a.withConfig({
  displayName: "Inner__InnerLink",
  componentId: "sc-h9rhyh-1"
})(["", ""], innerStyles);
export var ListCardInner = styled.div.withConfig({
  displayName: "Inner__ListCardInner",
  componentId: "sc-h9rhyh-2"
})(["width:180px;"]);